module.exports = __webpack_public_path__ + "static/media/app-store-de.b37fbda5.svg";